import * as React from 'react';
import jwt from 'jsonwebtoken';

import { useTheme } from '@material-ui/core/styles';
import {
  LineChart,
  Line,
  Tooltip,
  XAxis,
  YAxis,
  Label,
  ResponsiveContainer,
  // CartesianGrid,
  // Legend,
  // ComposedChart,
  // Area,
  // Bar,
} from 'recharts';

import API from '../../services/api';
import CustomAlert from '../custom/alert';
import { Typography } from '@material-ui/core';

export default function Chart() {
  const theme = useTheme();
  const decoded = jwt.decode(sessionStorage.getItem('token'));
  const load = React.useRef(true);
  const [alert, setAlert] = React.useState({ open: false, message: '' });
  const [state, setState] = React.useState({});

  function componentDidMount() {
    if (load.current) {
      API.Balance.show(decoded.uid).then(onSuccess).catch(onFailure);
    }
    return function componentWillUnmount() { load.current = false; };
  }

  function onSuccess(response) {
    if (load.current && response.data) {
      console.log(response.data);
      setState(response.data);
    }
  }

  function onFailure(error) {
    if (load.current && error) {
      console.log(error.message);
    }
  }

  React.useEffect(componentDidMount, []);

  return (
    <React.Fragment>
      <CustomAlert open={alert.open} onClose={() => setAlert({ ...alert, open: false })} >{alert.message}</CustomAlert>
      <Typography
        align="center"
        color="primary"
        variant="h6"
      >
        {'Meus saldos'}<br></br>
      </Typography>
      <ResponsiveContainer>
        <LineChart
          data={state.history}
          Tooltip={true}
          margin={{
            top: 16,
            right: 16,
            bottom: 0,
            left: 24,
          }}
        >
          <XAxis dataKey="date" stroke={theme.palette.text.secondary} />
          <YAxis stroke={theme.palette.text.secondary}>
            <Label
              angle={270}
              position="left"
              style={{
                textAnchor: 'middle',
                fill: theme.palette.text.primary,
              }}
            >
              Saldo (B$)
            </Label>
          </YAxis>
          <Tooltip />
          <Line type="monotone" dataKey="saldo" name="Meu saldo" stroke="#0000d8" />
        </LineChart>

      </ResponsiveContainer>
    </React.Fragment>
  );
}
